(function () {
  'use strict';

  // === AFTERPAY BADGE — product pages only ===
  function getPrice() {
    const sale = document.querySelector('.price__container .price-item--sale');
    const regular = document.querySelector('.price__container .price-item--regular');
    const el = sale || regular;
    if (!el) return null;
    const m = el.textContent.match(/([\d,]+\.?\d*)/);
    return m ? parseFloat(m[1].replace(',', '')) : null;
  }

  function renderBadge(price) {
    const existing = document.getElementById('sk-afterpay');
    if (existing) existing.remove();
    if (!price || price < 1 || price > 2000) return;
    const inst = (price / 4).toFixed(2);
    const badge = document.createElement('p');
    badge.id = 'sk-afterpay';
    badge.style.cssText = 'margin:6px 0 0; font-size:13px; color:#444; line-height:1.4;';
    badge.innerHTML =
      'or 4 x <strong>$' + inst + ' AUD</strong> with ' +
      '<a href="https://www.afterpay.com/en-AU/how-it-works" target="_blank" rel="noopener" ' +
      'style="color:#000; font-weight:700; text-decoration:none; background:#B2FCE4; padding:1px 5px; border-radius:3px;">Afterpay</a>' +
      ' &nbsp;<a href="https://www.afterpay.com/en-AU/how-it-works" target="_blank" rel="noopener" ' +
      'style="font-size:11px; color:#888;">ⓘ</a>';
    const container = document.querySelector('.price__container');
    if (container) container.after(badge);
  }

  function initAfterpay() {
    if (!window.location.pathname.includes('/products/')) return;
    renderBadge(getPrice());

    const observer = new MutationObserver(function () {
      renderBadge(getPrice());
    });
    const priceRoot = document.querySelector('.price');
    if (priceRoot) observer.observe(priceRoot, { childList: true, subtree: true, characterData: true });

    document.addEventListener('variant:changed', function () { renderBadge(getPrice()); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAfterpay(); });
  } else {
    initAfterpay();
  }
})();
